// extracted by mini-css-extract-plugin
export default {"textArea":"EmailDomainConfigContainer-textArea-60e50ab901f39641c2e3ccd654eb2fcf"};